<template>
<section id="clComparison">
  <h2 class="instH2">Обычный заём или кредитная линия?</h2>
  <div id="clComparisonWrap">
    <div class="clComparisonCol">
      <p class="clComparisonTitle">Обычный заём</p>
      <ul>
        <li>Выдаётся единовременно на конкретный срок. Для новой суммы — новый договор</li>
        <li>Проценты начисляются на полную сумму займа с первого дня</li>
        <li>Каждое обращение — полная заявка и проверка</li>
        <li>После погашения договор прекращается</li>
      </ul>
    </div>
    <div class="clComparisonCol accent">
      <p class="clComparisonTitle">Кредитная линия</p>
      <ul>
        <li>Одна заявка — кредитный лимит устанавливается на 10 лет</li>
        <li>Проценты начисляются только на использованную часть лимита</li>
        <li>Весь срок договора можно брать деньги частями, по мере необходимости</li>
        <li>После платежа лимит восстанавливается</li>
      </ul>
    </div>
  </div>
  <instApplyButton></instApplyButton>
</section>
</template>

<script>
export default {
  name: "clComparison",
  components: {
    instApplyButton: () => import('@/components/inst/instApplyButton.vue'),
  }
}
</script>

<style scoped>
#clComparisonWrap{display: flex;flex-direction: column;gap: var(--font-size-20);}
.clComparisonCol{background: white;border-radius: var(--font-size-20);padding: var(--font-size-24);font-family: 'Roboto';}
.clComparisonCol.accent{background: var(--color-gray-type4);border: var(--font-size-02) solid var(--color-green);}
.clComparisonTitle{font-weight: 700;font-size: var(--font-size-18);margin-bottom: var(--font-size-16);}
.clComparisonCol ul{list-style: none;}
.clComparisonCol li{font-size: var(--font-size-16);color:var(--color-gray-type3);padding-left: var(--font-size-21);position: relative;margin-bottom: var(--font-size-12);}
.clComparisonCol li:before{content:'';position: absolute;left:0;top:var(--font-size-08);width: var(--font-size-08);height: var(--font-size-08);border-radius: 50%;background: var(--color-gray-type3);}
.clComparisonCol.accent li:before{background: var(--color-green);}
.clComparisonCol.accent li{color:var(--color-black-type2);}

@media screen and (min-width: 760px) {
  #clComparisonWrap{flex-direction: row;gap: var(--font-size-30);}
  .clComparisonCol{width: 50%;padding: var(--font-size-40);}
}
</style>
